import { IOutfitCardData, IOutfitCardDataAction, IOutfitCard } from '../../../../models/outfit/outfitcard';
import { IStore } from '../../../IStore';
import { IComment, IPage, IEntityDto } from '../../../../models/common';
import { reset } from 'redux-form';
import * as c from 'models/constants';
import { IUserPreferences } from '../../../../models/user/userpreferences';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { browserHistory } from 'react-router';
import { goToErrorPage } from '../../error';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';

/** Action Types */
export const REQUEST_START: string = 'outfitcard/REQUEST_START';
export const GET_SUCCESS: string = 'outfitcard/GET_SUCCESS';
export const REQUEST_FAILURE: string = 'outfitcard/REQUEST_FAILURE';
export const RESET_COMMENTS_DATA: string = 'outfitcard/RESET_COMMENTS_DATA';
export const SET_IS_COMMENTS_FIRST_LOAD: string = 'outfitcard/SET_IS_COMMENTS_FIRST_LOAD';
export const GET_COMMENTS_SUCCESS: string = 'outfitcard/GET_COMMENTS_SUCCESS';
export const SET_COMMENTS_PAGE: string = 'outfitcard/SET_COMMENTS_PAGE';
export const RESET_DATA: string = 'outfitcard/RESET_DATA';
export const SET_IS_MY_PROFILE: string = 'outfitcard/SET_IS_MY_PROFILE';
export const SET_USER_IS_FOLLOWED: string = 'outfitcard/SET_USER_IS_FOLLOWED';
export const FOLLOW_USER_SUCCESS: string = 'outfitcard/FOLLOW_USER_SUCCESS';
export const UNFOLLOW_USER_SUCCESS: string = 'outfitcard/UNFOLLOW_USER_SUCCESS';
export const FOLLOW_USER_START: string = 'outfitcard/FOLLOW_USER_START';
export const LIKE_ITEM_SUCCESS: string = 'outfitcard/LIKE_ITEM_SUCCESS';

/** Initial State */
const initialState: IOutfitCardData = {
	isFetching: false,
	outfitCard: null,
	comments: [],
	commentsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 15,
		items: [],
	},
	isCommentsFirstLoad: false,
	isMyProfile: false,
};

/** Reducer */
export function outfitCardReducer(state = initialState, action: IOutfitCardDataAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				outfitCard: action.payload.outfitCard,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case RESET_COMMENTS_DATA:
			return Object.assign({}, state, {
				comments: [],
				commentsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 15,
					items: [],
				},
			});

		case SET_IS_COMMENTS_FIRST_LOAD:
			return Object.assign({}, state, {
				isCommentsFirstLoad: action.payload.isCommentsFirstLoad,
			});

		case GET_COMMENTS_SUCCESS:
			return Object.assign({}, state, {
				comments: action.payload.comments,
				isFetching: false,
			});

		case SET_COMMENTS_PAGE:
			return Object.assign({}, state, {
				commentsPage: action.payload.commentsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, initialState);

		case SET_IS_MY_PROFILE:
			return Object.assign({}, state, {
				isMyProfile: action.payload.isMyProfile,
			});

		case SET_USER_IS_FOLLOWED:
			return Object.assign({}, state, {
				userIsFollowed: action.payload.userIsFollowed,
			});

		case FOLLOW_USER_SUCCESS:
			return Object.assign({}, state, {
				userIsFollowed: true,
			});

		case UNFOLLOW_USER_SUCCESS:
			return Object.assign({}, state, {
				userIsFollowed: false,
			});

		case FOLLOW_USER_START:
			return Object.assign({}, state, {
				userIsFollowed: undefined,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});
		default:
			return state;
	}
}

/** Async Action Creator */
export function getOutfitCard(id: string, target?: string) {
	return (dispatch, getState: () => IStore) => {
		const userPreferences: IUserPreferences = getState().userPreferences;

		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + id,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOutfitCard) => {
						setOutfitCardData(res, userPreferences, dispatch);

						const url = `/outfits/${res.code}?userId=${res.userId}`;
						if (target && target.length > 0) {
							window.open(url, target);
						} else {
							browserHistory.push(url);
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(goToErrorPage(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(goToErrorPage(message));
						});
				}
			})
			.catch((err) => {
				dispatch(goToErrorPage(err));
			});
	};
}

/** Async Action Creator */
export function getOutfitCardByCode(code: string, userId: string) {
	return (dispatch, getState: () => IStore) => {
		const userPreferences: IUserPreferences = getState().userPreferences;

		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + code + '/GetByCode' + '?userId=' + userId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOutfitCard) => {
						setOutfitCardData(res, userPreferences, dispatch);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

function setOutfitCardData(res: IOutfitCard, userPreferences: IUserPreferences, dispatch) {
	dispatch(getOutfitCardSuccess(res));

	const likes = new Likes(LikeNodeType.OutfitCard);
	if (userPreferences && userPreferences.id) {
		if (userPreferences.id && userPreferences.id === res.userId) {
			dispatch(setIsMyProfile(true));
		} else {
			dispatch(getUserFollowButtonData());
		}

		dispatch(likes.getLikedItems());
	} else {
		dispatch(setUserIsFollowed(false));
		dispatch(likes.updateLikeItems(null));
	}
}

/** Action Creator */
export function getUserFollowButtonData() {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(requestStart());

		const entityIds: IEntityDto[] = [];
		entityIds.push({ entityId: getState().outfitCard.outfitCard.userEntityId });

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(entityIds),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(setUserIsFollowed(res[0].value)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function getOutfitComments(id: string, isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetCommentsData());
			dispatch(setIsCommentsFirstLoad(false));
		}

		dispatch(requestStart());

		const currentPage: number = getState().outfitCard.commentsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().outfitCard.commentsPage.itemsPerPage;

		let queryString = '?';
		queryString = queryString + '&currentPage=' + newPage;
		queryString = queryString + '&itemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + id + '/Comments' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						if (isFirstLoad) {
							dispatch(resetCommentsData());
						}
						const comments = getState().outfitCard.comments;
						const newComments: IComment[] = res.items;
						Array.prototype.push.apply(comments, newComments);
						dispatch(getOutfitCommentsSuccess(comments));
						dispatch(setOutfitCommentsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function addOutfitComment(comment: IComment, outfitId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + `api/Outfit/Comment`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(comment),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then(() => {
						dispatch(reset(c.FORM_NAME_ADD_COMMENT));
						dispatch(getOutfitComments(outfitId, true));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function followUser(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(followUserStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/' + id + '/Follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(followUserSuccess());
					dispatch(updateUserFollowersCount());
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowUser(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(followUserStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/' + id + '/Follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(unfollowUserSuccess());
					dispatch(updateUserFollowersCount(true));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateUserFollowersCount(isUnfollow: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const outfitCard: IOutfitCard = getState().outfitCard.outfitCard;
		if (isUnfollow) {
			outfitCard.userFollowersCount--;
		} else {
			outfitCard.userFollowersCount++;
		}
		dispatch(getOutfitCardSuccess(outfitCard));
	};
}

/** Action Creator */
export function requestStart(): IOutfitCardDataAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getOutfitCardSuccess(outfitCard: IOutfitCard): IOutfitCardDataAction {
	return {
		type: GET_SUCCESS,
		payload: {
			outfitCard,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IOutfitCardDataAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function resetCommentsData(): IOutfitCardDataAction {
	return {
		type: RESET_COMMENTS_DATA,
	};
}

export function setIsCommentsFirstLoad(isCommentsFirstLoad: boolean): IOutfitCardDataAction {
	return {
		type: SET_IS_COMMENTS_FIRST_LOAD,
		payload: {
			isCommentsFirstLoad,
		},
	};
}

/** Action Creator */
export function getOutfitCommentsSuccess(comments: IComment[]): IOutfitCardDataAction {
	return {
		type: GET_COMMENTS_SUCCESS,
		payload: {
			comments,
		},
	};
}

/** Action Creator */
export function setOutfitCommentsPage(commentsPage: IPage): IOutfitCardDataAction {
	return {
		type: SET_COMMENTS_PAGE,
		payload: {
			commentsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IOutfitCardDataAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setIsMyProfile(isMyProfile: boolean): IOutfitCardDataAction {
	return {
		type: SET_IS_MY_PROFILE,
		payload: {
			isMyProfile,
		},
	};
}

/** Action Creator */
export function setUserIsFollowed(userIsFollowed: boolean): IOutfitCardDataAction {
	return {
		type: SET_USER_IS_FOLLOWED,
		payload: {
			userIsFollowed,
		},
	};
}

/** Action Creator */
export function followUserSuccess(): IOutfitCardDataAction {
	return {
		type: FOLLOW_USER_SUCCESS,
	};
}

/** Action Creator */
export function followUserStart(): IOutfitCardDataAction {
	return {
		type: FOLLOW_USER_START,
	};
}

/** Action Creator */
export function unfollowUserSuccess(): IOutfitCardDataAction {
	return {
		type: UNFOLLOW_USER_SUCCESS,
	};
}

/** Action Creator */
export function likeItemSuccess(): IOutfitCardDataAction {
	return {
		type: LIKE_ITEM_SUCCESS,
	};
}
